import { Injectable } from '@angular/core';

import { NavbarComponent } from '../../components/navbar/navbar/navbar.component';

import { AuthService } from '../common/auth.service';
import { ActionCableService } from '../common/action-cable.service';
import { BrowserNotificationService } from '../common/browser-notification.service';
import { DataStoreService } from '../common/data-store.service';
import { NotyService } from '../common/noty.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationChannelService {
  /**
   * Subscription identifiers with key same as subscriptions object
   * @type {any}
   */
  subscriptionIdentifiers: any = {};

  /**
   * All subscriptions
   * @type {any}
   */
  subscriptions: any = {};

  /**
   * Channel Name
   * @type {string}
   */
  channelName: string = 'NotificationChannel';

  verifyingUserLoggedIn: boolean = false;

  /**
   * Constructor
   * @param {ActionCableService} private actionCableService ActionCable connection
   */
  constructor(private actionCableService: ActionCableService, private authService: AuthService, private browserNotificationService: BrowserNotificationService, private dataStoreService: DataStoreService, private notyService: NotyService) {}

  /**
   * Subscribe to notifications sent to browser
   * @param {string}     identifier Unique identifier for this notification subscription
   * @param {boolean}    reset Force unsubscribe and create new subscription if subscription is already present
   */
  connectForBrowserNotifications(identifier: string, reset: boolean = false) {
    let scope: NotificationChannelService = this;
    this.subscriptionIdentifiers.browserNotification = identifier;
    this.actionCableService.cable().then((cable) => {
      console.log('Subscribing to Browser Notifications', cable);
      if (this.subscriptions.browserNotification && reset) {
        this.subscriptions.browserNotification.unsubscribe();
        this.subscriptions.browserNotification = null;
      }
      if (!this.subscriptions.browserNotification)
        this.subscriptions.browserNotification = cable.subscriptions.create(
          {
            channel: this.channelName,
            identifier: this.subscriptionIdentifiers.browserNotification,
            action: 'browser_notification',
          },
          {
            connected: () => {
              console.log('Subscribed for Browser Notifications');
            },
            received: (data: any) => {
              if (data.title) {
                if (!data.options) data.options = {};
                this.browserNotificationService.showNotification(data.title, data.options);
              }
            },
            rejected: () => {
              console.log('Browser Notification subscription rejected');
            },
          }
        );
    });
  }

  connectForWebPageNotifications(identifier: string, reset: boolean = false) {
    let scope: NotificationChannelService = this;
    this.subscriptionIdentifiers.webNotification = identifier;
    this.actionCableService.cable().then((cable) => {
      console.log('Subscribing to Web Page Notifications', cable);
      if (this.subscriptions.webPageNotification && reset) {
        this.subscriptions.webPageNotification.unsubscribe();
        this.subscriptions.webPageNotification = null;
      }
      if (!this.subscriptions.webPageNotification)
        this.subscriptions.webPageNotification = cable.subscriptions.create(
          {
            channel: this.channelName,
            identifier: this.subscriptionIdentifiers.browserNotification,
            action: 'web_page_notification',
          },
          {
            connected: () => {
              console.log('Subscribed for Web Page Notifications');
            },
            received: (data: any) => {
              if (data.notify) {
                let navbarComponent: NavbarComponent = this.dataStoreService.retrieve('navbarComponent');
                if (navbarComponent) navbarComponent.newNotificationsPresent = true;
                if ((data.title || data.text) && data.url) scope.notyService.notify(`${data.title}<br />${data.text}`, 'alert', 10000, 'topRight', { closeButtonRequired: true, progressBar: true, trackNotification: true, url: data.url });
              }
            },
            rejected: () => {
              console.log('Web Page Notification subscription rejected');
            },
          }
        );
    });
  }

  verifyUserLoggedIn() {
    if (this.verifyingUserLoggedIn) return;
    this.verifyingUserLoggedIn = true;
    this.authService
      .getCurrentUserGroups(true)
      .then((response_json) => {
        if (!response_json.current_user_id) console.log('User not logged in');
        this.verifyingUserLoggedIn = false;
      })
      .catch((err) => {
        console.error(err);
        console.log('User not logged in');
        this.verifyingUserLoggedIn = false;
      });
  }
}
